export function areMissingFilters({ visit_names, future_bookings, membership_types = [] }) {
  return visit_names.length === 0 || (!future_bookings && membership_types.length === 0);
}

export const selectMissingRequiredFilters = ({ serviceBookings }) => {
  const { selectedFilters, future_bookings } = serviceBookings;

  return areMissingFilters({
    visit_names: selectedFilters.visit_names,
    future_bookings,
    membership_types: selectedFilters.membership_types
  });
};

// Single source of truth for the Update button's disabled state, reused by the
// chart-level controls (breakdown filters, group by, show percentage, heatmap
// cells). Those refetch without the Update button, so they must be inert
// whenever Update itself is.
export const selectChartControlsDisabled = (state) =>
  selectMissingRequiredFilters(state) || state.serviceBookings.isFiltersLoading;
